import React, { useState } from 'react';
import { X, ArrowRight } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import './Modal.css';
import ProductsPage from './ProductsPage';

const AluminumSystemsModal = ({ onClose }) => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const { t } = useLanguage();

  const categories = [
    { id: 'opening', image: 'https://images.pexels.com/photos/5691472/pexels-photo-5691472.jpeg?auto=compress&cs=tinysrgb&w=800' },
    { id: 'sliding', image: 'https://images.pexels.com/photos/7078253/pexels-photo-7078253.jpeg?auto=compress&cs=tinysrgb&w=800' },
    { id: 'doors', image: 'https://img.freepik.com/free-photo/ai-generated-modern-styled-entryway_23-2150692301.jpg?w=800' },
    { id: 'shutters', image: 'https://images.pexels.com/photos/30728904/pexels-photo-30728904.jpeg?auto=compress&cs=tinysrgb&w=800' },
    { id: 'shading', image: 'https://images.pexels.com/photos/1915705/pexels-photo-1915705.jpeg?auto=compress&cs=tinysrgb&w=800' },
    { id: 'curtain-wall', image: 'https://images.pexels.com/photos/432185/pexels-photo-432185.jpeg?auto=compress&cs=tinysrgb&w=800' },
  ];

  if (selectedCategory) {
    const cat = categories.find(c => c.id === selectedCategory);
    return (
      <ProductsPage
        category={{
          ...cat,
          title: t(`alum.cat.${cat.id}`),
          description: t(`alum.cat.${cat.id}.desc`),
        }}
        onBack={() => setSelectedCategory(null)}
        onClose={onClose}
      />
    );
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content aluminum-modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} aria-label={t('common.close')}>
          <X size={24} />
        </button>

        <div className="modal-header">
          <h2>{t('alum.title')}</h2>
        </div>

        <div className="modal-body">
          <div className="categories-intro">
            <p>{t('alum.intro')}</p>
          </div>

          <div className="product-categories-grid">
            {categories.map((category) => (
              <div key={category.id} className="category-card">
                <div className="category-image">
                  <img
                    src={category.image}
                    alt={t(`alum.cat.${category.id}`)}
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="category-content">
                  <h4>{t(`alum.cat.${category.id}`)}</h4>
                  <p>{t(`alum.cat.${category.id}.desc`)}</p>
                  <button
                    className="view-products-btn"
                    onClick={() => setSelectedCategory(category.id)}
                  >
                    {t('common.viewMore')}
                    <ArrowRight size={18} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AluminumSystemsModal;
